import FollowupItem from "./FollowupItem";

export default function FollowupTimeline({

    followups=[],

    filter="all",

    onComplete,

    onDelete,

    onEdit

}){

    const now=new Date();

    const filtered=followups.filter(item=>{

        const overdue=

            item.status==="pending"

            &&

            new Date(item.followup_at)<now;

        switch(filter){

            case "pending":

                return item.status==="pending";

            case "completed":

                return item.status==="completed";

            case "overdue":

                return overdue;

            default:

                return true;

        }

    });

    if(filtered.length===0){

        return(

            <div className="crm-followup-empty">

                <div className="crm-followup-empty-icon">

                    📅

                </div>

                <h4>

                    No Follow-ups Found

                </h4>

                <p>

                    There are no follow-ups matching the selected filter.

                </p>

            </div>

        );

    }

    return(

        <div className="crm-followup-timeline">

            {

                filtered.map(item=>

                    <FollowupItem

                        key={item.id}

                        followup={item}

                        onComplete={onComplete}

                        onDelete={onDelete}

                        onEdit={onEdit}

                    />

                )

            }

        </div>

    );

}